'use strict';

var fill = require('./fill.cjs');

function defaultOffset(arr) {
    const offset = [0];
    fill.fillOffset(offset, arr.length - 1);
    return offset;
}

exports.defaultOffset = defaultOffset;
//# sourceMappingURL=default.cjs.map
